// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_mv-2";
export var interactiveWrapper = "_mv-0";
export var shippingHoverPreview = "_mv-4";
export var summaryBadgeTrigger = "_mv-1";
export var widgetHoverPreviewList = "_mv-3";
export var widgetPreviewScale = "_mv-5";